module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "P2P_WETH",
	"sourceName": "contracts/levels/P2PSwapper.sol",
	"abi": [
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "src",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "guy",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "dst",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "Deposit",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "src",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "dst",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "src",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "Withdrawal",
			"type": "event"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"name": "allowance",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "guy",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"internalType": "uint8",
					"name": "",
					"type": "uint8"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "deposit",
			"outputs": [],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "dst",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "src",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "dst",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "wad",
					"type": "uint256"
				}
			],
			"name": "withdraw",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"stateMutability": "payable",
			"type": "receive"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/P2PSwapper.sol/P2P_WETH.json
// module id = 1593
// module chunks = 0